//
import ExtendModel from '@/models/ExtendModel'
import SelectedProviderPurchaseQuotationModel from '@/models/Purchase/PchSelectedProviderPurchaseQuotation'

/**
 * @class
 * @extends ExtendModel
 */
export default class PchPurchaseQuotation extends ExtendModel {
    //
    pch_selected_products_purchase_quotations = []
    pch_selected_providers_purchase_quotations = []

    //
    static includes = [
        'g_user.hr_employee',
        'g_branch_office',
        'pch_detail_purchase_quotations.wh_product',
        'pch_detail_providers_purchase_quotations.pch_provider',
        'pch_detail_providers_purchase_quotations.pch_provider_branch_offices',
    ]

    /**
     * @description
     *
     */
    get g_user_hr_employee_rut() {
        return this.g_user
            ? this.g_user.hr_employee
                ? this.g_user.hr_employee.rut
                : '-'
            : '-'
    }

    /**
     * @description
     *
     */
    get g_user_hr_employee_full_name() {
        return [
            this.g_user
                ? this.g_user.hr_employee
                    ? this.g_user.hr_employee.names
                    : ''
                : '',
            this.g_user
                ? this.g_user.hr_employee
                    ? this.g_user.hr_employee.last_name1
                    : ''
                : '',
            this.g_user
                ? this.g_user.hr_employee
                    ? this.g_user.hr_employee.last_name2
                    : ''
                : '',
        ].join(' ')
    }

    /**
     * @description
     *
     */
    get pch_providers_alias_names() {
        return this.pch_detail_providers_purchase_quotations.map(
            ({ pch_provider }) => pch_provider.alias_name
        )
    }

    /**
     * @description
     *
     */
    get pch_detail_purchase_quotations_length() {
        return this.pch_detail_purchase_quotations.length
    }

    /**
     * @description
     *
     */
    mapProduct(item) {
        return {
            quantity: Number(item.quantity),
            wh_product_id: parseInt(item.id, 10),
        }
    }

    /**
     * @description
     *
     */
    mapProductSelected(item) {
        return {
            ...item,
            ...item.wh_product,
        }
    }

    /**
     * @description
     *
     */
    mapProvider(item) {
        return {
            pch_provider_id: parseInt(item.id, 10),
            pch_provider_branch_offices_id: parseInt(
                item.pch_provider_branch_offices_id,
                10
            ),
        }
    }

    /**
     * @description
     *
     */
    mapProviderSelected(item) {
        return new SelectedProviderPurchaseQuotationModel({
            ...item,
            ...item.pch_provider,
            branch_offices: [item.pch_provider_branch_offices],
        }).reset()
    }

    /**
     * @description
     *
     */
    reset() {
        //
        this.pch_selected_products_purchase_quotations = this
            .pch_detail_purchase_quotations
            ? this.pch_detail_purchase_quotations.map(this.mapProductSelected)
            : []
        this.pch_selected_providers_purchase_quotations = this
            .pch_detail_providers_purchase_quotations
            ? this.pch_detail_providers_purchase_quotations.map(
                  this.mapProviderSelected
              )
            : []

        //
        return this
    }

    /**
     * @description
     *
     */
    resource() {
        return 'pch_purchase_quotation'
    }

    /**
     * @description
     *
     */
    toCreate() {
        //
        this.products = this.pch_selected_products_purchase_quotations.map(
            this.mapProduct
        )
        this.providers = this.pch_selected_providers_purchase_quotations.map(
            this.mapProvider
        )

        //
        return this.clean([
            'g_branch_office_id',
            'observation',
            'products',
            'providers',
        ])
    }

    /**
     * @description
     *
     */
    toUpdate() {
        //
        this.products = this.pch_selected_products_purchase_quotations.map(
            this.mapProduct
        )
        this.providers = this.pch_selected_providers_purchase_quotations.map(
            this.mapProvider
        )

        //
        return this.clean([
            'g_branch_office_id',
            'id',
            'observation',
            'products',
            'providers',
        ])
    }
}
